import * as yup from 'yup';

const ZIP_CODE_PL = /^\d{2}-\d{3}$/;
const PHONE_PL = /^\d{9}$/;
const EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const validationSchema = (intl) =>
  yup.object({
    name: yup
      .string('')
      .min(3, intl.formatMessage({ id: 'validation.name.min_length' }, { length: 3 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    street: yup
      .string('')
      .min(3, intl.formatMessage({ id: 'validation.street.min_length' }, { length: 3 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    zipCode: yup
      .string('')
      .matches(ZIP_CODE_PL, intl.formatMessage({ id: 'validation.zip_code.format' }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    city: yup
      .string('')
      .min(3, intl.formatMessage({ id: 'validation.city.min_length' }, { length: 3 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    contactPerson: yup.string().nullable(),
    phone: yup
      .string()
      .matches(PHONE_PL, {
        message: intl.formatMessage({ id: 'validation.phone.format' }),
        excludeEmptyString: true,
      })
      .nullable(),
    email: yup
      .string()
      .matches(EMAIL, {
        message: intl.formatMessage({ id: 'validation.email' }),
        excludeEmptyString: true,
      })
      .nullable(),
    notes: yup.string().nullable(),
  });

export default validationSchema;
